// extracted by mini-css-extract-plugin
var _1 = "ExtensionPost-module__animateUploadProgressBarWidth--_OFb3";
var _2 = "ExtensionPost-module__animatedBackground--LXWz1";
var _3 = "ExtensionPost-module__banner--jiIXs";
var _4 = "ExtensionPost-module__bannerContainer--L0Vbc";
var _5 = "ExtensionPost-module__button--Be3Fe";
var _6 = "ExtensionPost-module__buttonGroup--MRHCi";
var _7 = "ExtensionPost-module__container--XBmgP";
var _8 = "ExtensionPost-module__content--iArF5";
var _9 = "ExtensionPost-module__contentContainer--ctsUm";
var _a = "ExtensionPost-module__controlBarContainer--JNsmS";
var _b = "ExtensionPost-module__editorContainer--EbyA6";
var _c = "ExtensionPost-module__editorRoot--jFKBE";
var _d = "ExtensionPost-module__headerControls--epU_k";
var _e = "ExtensionPost-module__isMoveable--sZI61";
var _f = "ExtensionPost-module__magneticWallContainer--hqCeq";
var _10 = "ExtensionPost-module__padding--oI7wU";
var _11 = "ExtensionPost-module__resizeHandler--PN3iL";
var _12 = "ExtensionPost-module__scrollArea--H1zNy";
var _13 = "ExtensionPost-module__topicBarContainer--XjiqJ";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "banner", _4 as "bannerContainer", _5 as "button", _6 as "buttonGroup", _7 as "container", _8 as "content", _9 as "contentContainer", _a as "controlBarContainer", _b as "editorContainer", _c as "editorRoot", _d as "headerControls", _e as "isMoveable", _f as "magneticWallContainer", _10 as "padding", _11 as "resizeHandler", _12 as "scrollArea", _13 as "topicBarContainer" }
